module.exports = __webpack_public_path__ + "static/p3-c19ee96931d7e3d6d0009b69703faaba.jpg";